import React, { FC } from 'react'
import { useTheme } from '@shared/lib'

const PhoneIcon: FC = () => {
  const theme = useTheme()

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        d="M7.73736 3.05233C8.15847 2.95787 8.65108 2.99118 9.05206 3.1532C9.52492 3.34427 10.1855 3.69079 10.781 4.28631C11.6478 5.15299 12.0811 5.58633 12.1031 6.6226C12.1251 7.65888 11.6579 8.16754 10.7235 9.18487C10.4516 9.48082 10.1608 9.77231 9.86506 10.045L10.1701 10.4045L14.2611 14.4954L14.6185 14.7986C14.8912 14.5027 15.1828 14.2119 15.4788 13.9401C16.4962 13.0056 17.005 12.5384 18.0413 12.5604C19.0776 12.5824 19.5114 13.0162 20.3791 13.8839C20.9752 14.48 21.3221 15.1411 21.5133 15.6141C21.6754 16.0151 21.7089 16.5075 21.6146 16.9287C21.4598 17.6194 21.0888 18.711 20.2145 19.5468C19.7728 19.9794 19.3474 20.2913 18.8502 20.5225C17.1207 21.3266 15.071 21.048 13.3692 20.1867C12.0104 19.499 10.3932 18.49 8.37106 16.4679C6.34888 14.4458 5.16782 12.6567 4.48011 11.298C3.61878 9.59624 3.34009 7.54666 4.1443 5.81717C4.37408 5.32303 4.68357 4.89983 5.11203 4.46109C5.9488 3.58101 7.04456 3.20773 7.73736 3.05233Z"
        fill={theme.colors.icon.white}
      />
    </svg>
  )
}

export default PhoneIcon
